var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _radialGradient, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _linearGradient68, _linearGradient69, _linearGradient70, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 228,
    viewBox: "0 0 312 228",
    width: 312,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 220.337,
    x2: 194.2,
    y1: 0.88594,
    y2: 207.979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#464c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#302d4c"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 204.742,
    x2: -5.38406,
    y1: 7.65481,
    y2: 355.841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c344ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e98951"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f78f49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffbf46"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 185.89,
    x2: 87.6746,
    xlinkHref: "#c",
    y1: 208.406,
    y2: 208.007
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 185.891,
    x2: 87.6746,
    xlinkHref: "#c",
    y1: 197.832,
    y2: 197.432
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 185.889,
    x2: 87.6732,
    xlinkHref: "#c",
    y1: 203.173,
    y2: 202.857
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4d743"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 185.891,
    x2: 87.6746,
    xlinkHref: "#g",
    y1: 197.832,
    y2: 197.432
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f78f49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcb68"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 184.694,
    x2: 88.8301,
    xlinkHref: "#i",
    y1: 197.96,
    y2: 197.611
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 184.257,
    x2: 89.3263,
    xlinkHref: "#g",
    y1: 198.627,
    y2: 198.312
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 173.249,
    x2: 75.033,
    xlinkHref: "#c",
    y1: 197.662,
    y2: 197.262
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 173.249,
    x2: 75.0331,
    xlinkHref: "#c",
    y1: 187.087,
    y2: 186.688
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 173.247,
    x2: 75.0316,
    xlinkHref: "#c",
    y1: 192.429,
    y2: 192.113
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 173.249,
    x2: 75.0331,
    xlinkHref: "#g",
    y1: 187.087,
    y2: 186.688
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 172.053,
    x2: 76.1884,
    xlinkHref: "#i",
    y1: 187.216,
    y2: 186.867
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 171.615,
    x2: 76.6845,
    xlinkHref: "#g",
    y1: 187.883,
    y2: 187.568
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 185.049,
    x2: 86.8329,
    xlinkHref: "#c",
    y1: 185.49,
    y2: 185.091
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 185.049,
    x2: 86.8329,
    xlinkHref: "#c",
    y1: 174.916,
    y2: 174.517
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 185.047,
    x2: 86.8315,
    xlinkHref: "#c",
    y1: 180.257,
    y2: 179.942
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 185.049,
    x2: 86.8329,
    xlinkHref: "#g",
    y1: 174.916,
    y2: 174.517
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 183.853,
    x2: 87.9883,
    xlinkHref: "#i",
    y1: 175.045,
    y2: 174.696
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    gradientUnits: "userSpaceOnUse",
    x1: 183.415,
    x2: 88.4844,
    xlinkHref: "#g",
    y1: 175.712,
    y2: 175.397
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 192.296,
    x2: 94.0797,
    xlinkHref: "#c",
    y1: 172.752,
    y2: 172.353
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    gradientUnits: "userSpaceOnUse",
    x1: 192.296,
    x2: 94.0798,
    xlinkHref: "#c",
    y1: 162.178,
    y2: 161.779
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    gradientUnits: "userSpaceOnUse",
    x1: 192.294,
    x2: 94.0783,
    xlinkHref: "#c",
    y1: 167.519,
    y2: 167.204
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 192.296,
    x2: 94.0798,
    xlinkHref: "#g",
    y1: 162.178,
    y2: 161.779
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 191.1,
    x2: 95.2351,
    xlinkHref: "#i",
    y1: 162.307,
    y2: 161.958
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 190.663,
    x2: 95.7317,
    xlinkHref: "#g",
    y1: 162.974,
    y2: 162.659
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 187.07,
    x2: 88.8544,
    xlinkHref: "#c",
    y1: 160.457,
    y2: 160.058
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 187.07,
    x2: 88.8544,
    xlinkHref: "#c",
    y1: 149.883,
    y2: 149.484
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientUnits: "userSpaceOnUse",
    x1: 187.069,
    x2: 88.853,
    xlinkHref: "#c",
    y1: 155.224,
    y2: 154.909
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 187.07,
    x2: 88.8544,
    xlinkHref: "#g",
    y1: 149.883,
    y2: 149.484
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    gradientUnits: "userSpaceOnUse",
    x1: 185.875,
    x2: 90.0107,
    xlinkHref: "#i",
    y1: 150.012,
    y2: 149.662
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    gradientUnits: "userSpaceOnUse",
    x1: 185.438,
    x2: 90.5068,
    xlinkHref: "#g",
    y1: 150.678,
    y2: 150.364
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    gradientUnits: "userSpaceOnUse",
    x1: 172.743,
    x2: 74.5273,
    xlinkHref: "#c",
    y1: 151.291,
    y2: 150.892
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    gradientUnits: "userSpaceOnUse",
    x1: 172.743,
    x2: 74.5273,
    xlinkHref: "#c",
    y1: 140.717,
    y2: 140.318
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    gradientUnits: "userSpaceOnUse",
    x1: 172.742,
    x2: 74.526,
    xlinkHref: "#c",
    y1: 146.058,
    y2: 145.743
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientUnits: "userSpaceOnUse",
    x1: 172.743,
    x2: 74.5273,
    xlinkHref: "#g",
    y1: 140.717,
    y2: 140.318
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    gradientUnits: "userSpaceOnUse",
    x1: 171.548,
    x2: 75.6837,
    xlinkHref: "#i",
    y1: 140.846,
    y2: 140.496
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    gradientUnits: "userSpaceOnUse",
    x1: 171.11,
    x2: 76.1789,
    xlinkHref: "#g",
    y1: 141.512,
    y2: 141.198
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse",
    x1: 185.554,
    x2: 87.3376,
    xlinkHref: "#c",
    y1: 136.626,
    y2: 136.227
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    gradientUnits: "userSpaceOnUse",
    x1: 185.554,
    x2: 87.3378,
    xlinkHref: "#c",
    y1: 126.052,
    y2: 125.653
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    gradientUnits: "userSpaceOnUse",
    x1: 185.552,
    x2: 87.3363,
    xlinkHref: "#c",
    y1: 131.393,
    y2: 131.078
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    gradientUnits: "userSpaceOnUse",
    x1: 185.554,
    x2: 87.3378,
    xlinkHref: "#g",
    y1: 126.052,
    y2: 125.653
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    gradientUnits: "userSpaceOnUse",
    x1: 184.357,
    x2: 88.4931,
    xlinkHref: "#i",
    y1: 126.181,
    y2: 125.832
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    gradientUnits: "userSpaceOnUse",
    x1: 183.919,
    x2: 88.9884,
    xlinkHref: "#g",
    y1: 126.848,
    y2: 126.533
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    gradientUnits: "userSpaceOnUse",
    x1: 178.307,
    x2: 80.0907,
    xlinkHref: "#c",
    y1: 124.647,
    y2: 124.248
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    gradientUnits: "userSpaceOnUse",
    x1: 178.307,
    x2: 80.0907,
    xlinkHref: "#c",
    y1: 114.073,
    y2: 113.674
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    gradientUnits: "userSpaceOnUse",
    x1: 178.305,
    x2: 80.0893,
    xlinkHref: "#c",
    y1: 119.414,
    y2: 119.099
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    gradientUnits: "userSpaceOnUse",
    x1: 178.307,
    x2: 80.0907,
    xlinkHref: "#g",
    y1: 114.073,
    y2: 113.674
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    gradientUnits: "userSpaceOnUse",
    x1: 177.111,
    x2: 81.2461,
    xlinkHref: "#i",
    y1: 114.202,
    y2: 113.853
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    gradientUnits: "userSpaceOnUse",
    x1: 176.672,
    x2: 81.7414,
    xlinkHref: "#g",
    y1: 114.869,
    y2: 114.554
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    gradientUnits: "userSpaceOnUse",
    x1: 108.341,
    x2: 147.746,
    y1: 115.323,
    y2: 115.24
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a86f00"
  }))), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    gradientUnits: "userSpaceOnUse",
    x1: 143.495,
    x2: 143.495,
    y1: 23.9064,
    y2: 116.145
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffaa0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbc140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffaa0b"
  }))), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    gradientUnits: "userSpaceOnUse",
    x1: 148.809,
    x2: 150.281,
    y1: 23.3902,
    y2: 114.803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7dd50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7dd50"
  }))), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    gradientUnits: "userSpaceOnUse",
    x1: 148.82,
    x2: 150.217,
    y1: 25.7856,
    y2: 112.409
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f09a41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f09a41"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "af",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(-36.38556219 27.61914584 -27.93094477 -36.79632722 161.961 65.2572)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb9f42"
  }))), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    gradientUnits: "userSpaceOnUse",
    x1: 61.1731,
    x2: 51.8014,
    y1: 170.803,
    y2: 170.418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40468c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32366d"
  }))), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    gradientUnits: "userSpaceOnUse",
    x1: 53.849,
    x2: 23.5865,
    y1: 133.903,
    y2: 202.02
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40468c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373971"
  }))), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    gradientUnits: "userSpaceOnUse",
    x1: 102.293,
    x2: 99.3086,
    y1: 92.0321,
    y2: 93.2258
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1dcc7",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6b88c"
  }))), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    gradientUnits: "userSpaceOnUse",
    x1: 63.4481,
    x2: 65.3187,
    y1: 86.5031,
    y2: 80.3702
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3b376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e18438"
  }))), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab7ff2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e71e6"
  }))), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    gradientUnits: "userSpaceOnUse",
    x1: 107.859,
    x2: 69.1459,
    xlinkHref: "#ak",
    y1: 98.6196,
    y2: 104.107
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    gradientUnits: "userSpaceOnUse",
    x1: 70.8306,
    x2: 42.5081,
    xlinkHref: "#ak",
    y1: 128.716,
    y2: 128.933
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    gradientUnits: "userSpaceOnUse",
    x1: 255.041,
    x2: 255.03,
    y1: 91.4956,
    y2: 95.9622
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3b376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee7400"
  }))), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    gradientUnits: "userSpaceOnUse",
    x1: 259.056,
    x2: 256.587,
    y1: 91.2275,
    y2: 98.6433
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3b376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8964f"
  }))), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    gradientUnits: "userSpaceOnUse",
    x1: 274.714,
    x2: 266.787,
    y1: 171.329,
    y2: 171.681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#632a62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#330f36"
  }))), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    gradientUnits: "userSpaceOnUse",
    x1: 253.792,
    x2: 259.038,
    y1: 156.885,
    y2: 196.307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#632a62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#531452"
  }))), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    gradientUnits: "userSpaceOnUse",
    x1: 257.37,
    x2: 279.365,
    y1: 107.355,
    y2: 147.282
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f471b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f13a75"
  }))), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    gradientUnits: "userSpaceOnUse",
    x1: 257.595,
    x2: 293.312,
    y1: 83.4984,
    y2: 122.989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e2b5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41438e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m154.264 227.34c77.466 0 140.264-6.302 140.264-14.075 0-7.774-62.798-14.075-140.264-14.075-77.4657 0-140.264 6.301-140.264 14.075 0 7.773 62.7983 14.075 140.264 14.075z",
    fill: "#dae1e8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m259.489 8.72666c.25-2.19998-.454-4.40183-1.935-6.04786s-3.596-2.578675-5.81-2.561376c-22.376.175622-81.108.635926-96.88.759651-2.255.017675-4.145 1.710335-4.41 3.949795-2.995 25.31773-19.587 165.57813-22.797 192.71913-.142 1.196.205 2.399.961 3.337.757.937 1.86 1.53 3.06 1.644 16.882 1.606 75.953 7.222 97.046 9.228 4.197.399 7.94-2.635 8.417-6.824 3.715-32.617 18.389-161.45 22.348-196.20434z",
    fill: "#181233",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m254.339 5.12305c.146-1.27373-.261-2.54858-1.118-3.50153-.857-.953322-2.082-1.493349-3.363-1.483196-18.716.146665-83.828.656987-100.559.788233-2.254.017675-4.143 1.708833-4.41 3.947543-3.003 25.2644-19.623 165.0549-22.845 192.1539-.142 1.196.204 2.4.961 3.338s1.86 1.532 3.06 1.646c17.836 1.696 82.734 7.867 100.23 9.531 2.428.23 4.593-1.525 4.871-3.947 3.114-27.209 19.847-173.4126 23.173-202.47295z",
    fill: "url(#a)",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m230.2 3.72031c-.56.00457-1.028.42266-1.101.9782-.251 1.98457-.803 6.32269-.803 6.32269-.362 3.0534-2.943 5.357-6.02 5.3715-11.492.0529-38.385.1771-50.764.2342-1.675.0076-3.28-.6751-4.437-1.8875-1.156-1.2124-1.762-2.8474-1.675-4.5209 0 0 .268-2.99929.423-4.73332.027-.30766-.076-.61266-.286-.84036-.209-.22732-.504-.35602-.812-.35487-3.476.01599-13.268.06054-13.268.06054-2.011.01637-3.696 1.52498-3.933 3.52174-2.816 23.67927-19.082 160.47977-22.1 185.85877-.126 1.067.182 2.139.855 2.976.673.836 1.655 1.366 2.724 1.47 16.527 1.609 78.625 7.651 94.868 9.232 2.167.211 4.105-1.355 4.353-3.52 2.924-25.531 19.316-168.6032 22.438-195.85418.13-1.1366-.232-2.27396-.997-3.1246-.766-.85064-1.858-1.33232-3.005-1.32318 0 0-12.782.10357-16.46.13327z",
    fill: "url(#b)",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m86.6611 208.652c0 9.959 99.4529 9.959 99.4529 0 0-7.872-99.4529-7.872-99.4529 0z",
    fill: "url(#d)",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m86.6611 198.078c0 9.958 99.4529 9.958 99.4529 0 0-7.872-99.4529-7.872-99.4529 0z",
    fill: "url(#e)",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m186.113 198.079h-99.4519v10.574h99.4519z",
    fill: "url(#f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m86.6611 198.078c0 9.958 99.4529 9.958 99.4529 0 0-7.872-99.4529-7.872-99.4529 0z",
    fill: "url(#h)",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m87.8408 198.176c0 8.716 97.0722 8.716 97.0722 0 0-6.89-97.0722-6.89-97.0722 0z",
    fill: "url(#j)",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m88.3467 198.821c0 7.855 96.1263 7.855 96.1263 0 0-6.208-96.1263-6.208-96.1263 0z",
    fill: "url(#k)",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m74.0195 197.908c0 9.959 99.4535 9.959 99.4535 0 0-7.872-99.4535-7.872-99.4535 0z",
    fill: "url(#l)",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m74.0196 187.334c0 9.958 99.4534 9.958 99.4534 0 0-7.872-99.4534-7.872-99.4534 0z",
    fill: "url(#m)",
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m173.472 187.334h-99.4525v10.575h99.4525z",
    fill: "url(#n)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m74.0196 187.334c0 9.958 99.4534 9.958 99.4534 0 0-7.872-99.4534-7.872-99.4534 0z",
    fill: "url(#o)",
    fillRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m75.1992 187.432c0 8.716 97.0718 8.716 97.0718 0 0-6.89-97.0718-6.89-97.0718 0z",
    fill: "url(#p)",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m75.7049 188.077c0 7.855 96.1271 7.855 96.1271 0 0-6.208-96.1271-6.208-96.1271 0z",
    fill: "url(#q)",
    fillRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m85.8194 185.736c0 9.959 99.4536 9.959 99.4536 0 0-7.871-99.4536-7.871-99.4536 0z",
    fill: "url(#r)",
    fillRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m85.8194 175.162c0 9.959 99.4536 9.959 99.4536 0 0-7.872-99.4536-7.872-99.4536 0z",
    fill: "url(#s)",
    fillRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m185.271 175.163h-99.4516v10.574h99.4516z",
    fill: "url(#t)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m85.8194 175.162c0 9.959 99.4536 9.959 99.4536 0 0-7.872-99.4536-7.872-99.4536 0z",
    fill: "url(#u)",
    fillRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m86.9991 175.26c0 8.716 97.0719 8.716 97.0719 0 0-6.889-97.0719-6.889-97.0719 0z",
    fill: "url(#v)",
    fillRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m87.5048 175.906c0 7.854 96.1272 7.854 96.1272 0 0-6.209-96.1272-6.209-96.1272 0z",
    fill: "url(#w)",
    fillRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m93.0662 172.999c0 9.958 99.4528 9.958 99.4528 0 0-7.872-99.4528-7.872-99.4528 0z",
    fill: "url(#x)",
    fillRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m93.0663 162.424c0 9.959 99.4537 9.959 99.4537 0 0-7.871-99.4537-7.871-99.4537 0z",
    fill: "url(#y)",
    fillRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m192.518 162.425h-99.4518v10.574h99.4518z",
    fill: "url(#z)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m93.0663 162.424c0 9.959 99.4537 9.959 99.4537 0 0-7.871-99.4537-7.871-99.4537 0z",
    fill: "url(#A)",
    fillRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m94.2459 162.523c0 8.715 97.0721 8.715 97.0721 0 0-6.89-97.0721-6.89-97.0721 0z",
    fill: "url(#B)",
    fillRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m94.7521 163.168c0 7.854 96.1269 7.854 96.1269 0 0-6.208-96.1269-6.208-96.1269 0z",
    fill: "url(#C)",
    fillRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m87.8409 160.703c0 9.959 99.4531 9.959 99.4531 0 0-7.872-99.4531-7.872-99.4531 0z",
    fill: "url(#D)",
    fillRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m87.8409 150.129c0 9.959 99.4531 9.959 99.4531 0 0-7.872-99.4531-7.872-99.4531 0z",
    fill: "url(#E)",
    fillRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m187.293 150.13h-99.4521v10.574h99.4521z",
    fill: "url(#F)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m87.8409 150.129c0 9.959 99.4531 9.959 99.4531 0 0-7.872-99.4531-7.872-99.4531 0z",
    fill: "url(#G)",
    fillRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m89.0215 150.227c0 8.716 97.0725 8.716 97.0725 0 0-6.889-97.0725-6.889-97.0725 0z",
    fill: "url(#H)",
    fillRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m89.5272 150.873c0 7.854 96.1268 7.854 96.1268 0 0-6.209-96.1268-6.209-96.1268 0z",
    fill: "url(#I)",
    fillRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m73.5139 151.537c0 9.959 99.4531 9.959 99.4531 0 0-7.872-99.4531-7.872-99.4531 0z",
    fill: "url(#J)",
    fillRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m73.5138 140.963c0 9.959 99.4532 9.959 99.4532 0 0-7.872-99.4532-7.872-99.4532 0z",
    fill: "url(#K)",
    fillRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m172.966 140.964h-99.4521v10.574h99.4521z",
    fill: "url(#L)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m73.5138 140.963c0 9.959 99.4532 9.959 99.4532 0 0-7.872-99.4532-7.872-99.4532 0z",
    fill: "url(#M)",
    fillRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m74.6945 141.061c0 8.716 97.0725 8.716 97.0725 0 0-6.889-97.0725-6.889-97.0725 0z",
    fill: "url(#N)",
    fillRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m75.1993 141.707c0 7.854 96.1267 7.854 96.1267 0 0-6.209-96.1267-6.209-96.1267 0z",
    fill: "url(#O)",
    fillRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m86.3242 136.873c0 9.958 99.4528 9.958 99.4528 0 0-7.872-99.4528-7.872-99.4528 0z",
    fill: "url(#P)",
    fillRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m86.3243 126.298c0 9.959 99.4527 9.959 99.4527 0 0-7.871-99.4527-7.871-99.4527 0z",
    fill: "url(#Q)",
    fillRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m185.776 126.299h-99.4518v10.574h99.4518z",
    fill: "url(#R)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m86.3243 126.298c0 9.959 99.4527 9.959 99.4527 0 0-7.871-99.4527-7.871-99.4527 0z",
    fill: "url(#S)",
    fillRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m87.5038 126.397c0 8.715 97.0722 8.715 97.0722 0 0-6.89-97.0722-6.89-97.0722 0z",
    fill: "url(#T)",
    fillRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m88.0089 127.042c0 7.854 96.1271 7.854 96.1271 0 0-6.208-96.1271-6.208-96.1271 0z",
    fill: "url(#U)",
    fillRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m79.0772 124.894c0 9.958 99.4528 9.958 99.4528 0 0-7.872-99.4528-7.872-99.4528 0z",
    fill: "url(#V)",
    fillRule: "evenodd"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m79.0772 114.319c0 9.959 99.4528 9.959 99.4528 0 0-7.871-99.4528-7.871-99.4528 0z",
    fill: "url(#W)",
    fillRule: "evenodd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m178.529 114.32h-99.4518v10.574h99.4518z",
    fill: "url(#X)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m79.0772 114.319c0 9.959 99.4528 9.959 99.4528 0 0-7.871-99.4528-7.871-99.4528 0z",
    fill: "url(#Y)",
    fillRule: "evenodd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m80.2569 114.418c0 8.715 97.0721 8.715 97.0721 0 0-6.89-97.0721-6.89-97.0721 0z",
    fill: "url(#Z)",
    fillRule: "evenodd"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m80.7618 115.063c0 7.854 96.1262 7.854 96.1262 0 0-6.208-96.1262-6.208-96.1262 0z",
    fill: "url(#aa)",
    fillRule: "evenodd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m129.388 117.078c12.054 0 21.826-.852 21.826-1.903 0-1.052-9.772-1.904-21.826-1.904s-21.826.852-21.826 1.904c0 1.051 9.772 1.903 21.826 1.903z",
    fill: "url(#ab)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m143.495 116.143c26.455 0 47.9-20.6481 47.9-46.1192s-21.445-46.1195-47.9-46.1195c-26.454 0-47.8999 20.6484-47.8999 46.1195s21.4459 46.1192 47.8999 46.1192z",
    fill: "url(#ac)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m148.809 114.801c25.2 0 45.629-20.4632 45.629-45.7062 0-25.2431-20.429-45.7066-45.629-45.7066s-45.629 20.4635-45.629 45.7066c0 25.243 20.429 45.7062 45.629 45.7062z",
    fill: "url(#ad)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m148.82 112.407c23.903 0 43.28-19.3914 43.28-43.3117s-19.377-43.3116-43.28-43.3116-43.28 19.3913-43.28 43.3116 19.377 43.3117 43.28 43.3117z",
    fill: "url(#ae)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m148.047 112.404c23.476 0 42.507-19.1041 42.507-42.6697s-19.031-42.6694-42.507-42.6694-42.507 19.1038-42.507 42.6694 19.031 42.6697 42.507 42.6697z",
    fill: "url(#af)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.9622 208.457c-.1491-.44.9436-.518 1.0018-1.049.0685-.624.2372-1.245.2154-1.88-.0213-.621-.1749-1.351.0749-1.947.2137-.509.7268-1.22 1.3702-1.016.7326.235 1.0124 1.055 1.0652 1.695.1089 1.321-.3549 2.996-.3035 4.443.0652 1.838.4686 2.053-1.0182 2.831-.9959.523-2.1717-2.389-2.4058-3.077z",
    fill: "#f7a15b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.8574 208.104c.1192.117.268.212.4215.279.4423.191 1.6919.18 2.0217.588.7813.965-.1983 2.395.3805 3.477.3178.596.7908.965 1.3975 1.239.3301.151.7363.23 1.0222.462.2501.204.2719.71.0036.912-.8462.632-1.9226-.109-2.7509-.389-.8577-.291-2.1162-.241-2.8125-.867-.2991-.272-.3108-.806-.3035-1.181.0145-.741.0134-1.359-.2814-2.053-.2034-.478-.5906-.783-.6708-1.334-.0826-.563.3233-1.013.814-1.223.231-.098.5307-.21.6439-.031",
    fill: "#742f5e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.1087 211.043c-.0971-.4.0688-.777.2431-1.295.3782-1.124-.0758-2.529-.3167-3.774-.1292-.668-.0106-1.949 1.5148-2.047 1.5011-.098 1.9092 1.432 1.4426 3.597-.1373.638-.2946 1.312-.2389 1.964.0652.769.4658 1.757.0722 2.495-.1469.277-.4957.356-.7802.392-.6591.087-1.7352-.501-1.9369-1.332z",
    fill: "#e18438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.758 209.611c1.7215.993 3.4735 2.294 5.4295 2.794.5102.129 1.9976.207 2.1985.845.0898.286-.1989.445-.4185.537-.5377.232-1.1651.311-1.7476.297-.9824-.025-1.9724-.369-2.9344-.543-.8149-.148-1.6522-.145-2.478-.171-.8646-.022-2.1386.277-2.9123-.193-.9349-.567-.5178-1.837-.1947-2.64.1233-.308.2397-.646.4982-.87.5765-.498 1.0437.03 1.6661.03.3337-.002.7503-.193 1.0686-.022",
    fill: "#742f5e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.3708 207.533c1.5704-11.349 2.7783-22.444 3.3938-31.977.6154-9.534.6618-23.82.4476-33.552-.6468-29.35-33.5109-25.286-24.7922-6.493 8.7186 18.793 10.7319 20.969 11.7418 28.22 1.0098 7.251.5759 10.622.8747 18.147s1.2753 11.562 2.749 17.117c1.4737 5.559 1.691 6.454 2.1884 8.107.317 1.055 3.2758 1.309 3.3969.431z",
    fill: "url(#ag)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.5401 204.624c-.261.722-4.3553.392-4.6591-.171-.2831-.523-.4087-1.521-.5041-3.222-.0867-1.547-.1625-6.619-.033-8.499.3435-4.99.2375-7.133 1.0871-12.059.7181-4.166 2.6709-8.636 4.2929-12.552 1.2728-3.072 3.1112-5.774 4.1015-8.997 2.1741-7.074 2.8282-14.652 6.1753-21.347.9553-1.91 2.2362-3.773 3.9737-5.057 3.3473-2.47 8.4498-2.479 12.4257-2.221 1.7601.114 3.9172.361 5.3178 1.563.9995.859 1.4824 2.437.5581 3.475 0 0-15.3364 22.815-21.3662 37.2-5.3069 12.658-6.5476 16.101-8.1152 21.288-1.0731 3.55-2.5294 8.591-3.2545 10.599z",
    fill: "url(#ah)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.582 74.4327c-.041-.0056.005-.084.001-.1259-.007-.0812-.018-.1623-.028-.2462-.03-.249-.079-.4896-.135-.7357-.186-.8029-.622-1.5134-.788-2.3275-.054-.2685-.146-.6741-.002-.9315.158-.2797.325-.1454.452.0728.186.3189.355.649.53.9763.045.0839.154.4251.303.33.234-.151.375-.6126.466-.8532.263-.6909.481-1.4099.772-2.0868.165-.3805.484-.4476.764.0028.173.2769.478.5818.503 1.0826.04.6909-.056 1.0266-.274 1.6337-.31.8615-.624 1.7567-1.135 2.526-.062.0923-.124.1874-.188.2769-.203.2881-.932 1.2644-1.188.4952-.028-.084-.042-.1735-.051-.2602",
    fill: "#f1d6bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.8724 92.3525c-.059-.3534-.0723-.7313-.0564-1.2843.0096-.3287.257-.5315.454-.5807.312-.0768.568-.2703.911.0861.211.2181.425 1.0507.553 1.3026.16.3134.622 1.0016.776 1.3795.116.2827.338.9586.364 1.2474.033.3595.055 1.0385.002 1.3949-.049.3226-.317.5438-.596.3471-.119-.0092-.351-.1781-.569-.5591-.152-.2642-.369-.5961-.484-.7835-.168-.2765-.457-.6236-.627-.9002-.17-.2765-.194-.2366-.346-.553-.195-.4025-.3325-.7988-.3816-1.0968z",
    fill: "url(#ai)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.5928 84.4697c.6401-1.8095 1.0838-3.8017 1.2364-4.8116.4483-2.961 3.8662-2.1568 3.5285.4889-.2202 1.7227-.7653 3.852-1.8497 6.6759-3.0057 7.8274-6.2043 4.9304-5.0716 2.0654.7142-1.8049 1.4668-2.4674 2.1564-4.4186z",
    fill: "url(#aj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.5626 80.4109c-1.2716-2.8374-.3826-4.8711.4317-5.9029.866-1.0978 2.2155-1.8116 3.5844-1.8896 1.3693-.078 3.3418.222 4.4122 2.8375 1.0092 2.4715 1.4587 4.901 1.0448 7.0126-.2885 1.4697-2.8877.4499-4.9244-.072-2.1194-.5339-3.6686-.0179-4.5487-1.9856z",
    fill: "#f3b376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.9763 70.3961c1.8922-1.7912 8.6307-8.3437 8.9825-.9687.1901 3.9937-.7809 5.0584-6.6055 5.9494-1.3941.2148-3.2141 2.3167-2.181 3.8657 1.5175 2.271-1.4919 5.6889-4.0325-2.2893-.8408-2.6365 2.3231-5.1268 3.8365-6.5571z",
    fill: "#693474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.8794 99.249c3.8271 1.158 8.0271.3581 10.4186-.7385 2.3915-1.0938 3.9276-2.1848 5.9059-3.4967 2.0791-1.3791 6.8011-1.2141 3.9661 4.2436-2.835 5.4576-6.2371 9.5696-12.1485 12.8346-4.4414 2.45-7.9737 2.663-12.1203 2.864-4.4666.216-10.9744.056-15.194-2.098-3.9471-2.014-6.1629-5.801-6.4816-9.785-.4081-5.1052 1.3089-8.0452 3.2481-10.2552 2.0407-2.3246 6.7056-4.4199 10.6779-3.8828 3.3723.4532 5.3344 1.5554 7.3205 4.101 1.7512 2.2435 2.2525 5.5584 4.4073 6.213z",
    fill: "url(#al)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.3937 135.212c-1.4424-8.348 4.5301-35.8851 19.3932-44.6857 12.6042-7.4634 22.0462-5.606 32.6419-5.4521 6.3641.0923 12.2078-.6182 16.3312-3.1191 3.422-2.0757 5.678-4.5262 7.538-6.8089 1.86-2.2854 4.098-3.2002 3.642 2.2379-.364 4.3528-3.711 11.1449-10.9571 14.6192-6.6866 3.2086-14.6468 1.7232-20.2117 8.6247-5.3679 6.66-7.0105 10.518-6.9322 18.93.0355 3.818-.1623 9.276-1.133 13.483-.9295 4.031-4.497 10.001-10.914 10.384-4.485.266-4.2137-1.474-9.3959-1.527-5.1824-.056-4.882 1.314-11.5574 1.292-4.3975-.017-7.9018-4.834-8.445-7.978z",
    fill: "url(#am)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.246 84.0125c-.906.8504-1.57.2714-2.575 2.7974-.49 1.2309-.845 2.7639-.845 4.0591 0 .8867.06 2.6211 1.185 2.9036.514.1259 2.366-.3468 2.694-.6378 1.125-1.0014.926-1.7567 1.808-2.2826.664-.3944.985-.5931 1.541-1.1498 1.266-1.2644 1.067-3.8716-.044-5.1611-.944-1.0966-2.571-1.6421-3.692-.5232",
    fill: "url(#an)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.555 100.229c-.179.017.141-.3296.212-.4946.133-.3077.257-.6183.377-.9316.383-.9987.805-2.3274.863-3.396.163-3.024.445-4.129 1.514-6.3809.253-.5315 1.141-1.9889 1.925-1.6756.414.165.51.8028.608 1.1749.288 1.091.541 2.168.573 3.3037.099 3.5192-1.094 7.0746-2.91 10.0591-.322.529-.668 1.055-1.067 1.533-.27.322-.568.619-.888.89-1.207 1.027-2.227.512-2.261-1.002-.031-1.367.816-2.243 1.219-3.4516",
    fill: "url(#ao)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.065 212.654c-.777-.154-.979-.56-.291-1.897.277-.537.451-.976.546-2.154.145-1.785-.448-3.119-.386-4.367.098-2.064 4.196-3.289 3.222 2.462-.05.297-.305 1.251-.484 2.431-.081.532-.162 1.804-.162 2.381 0 .209.148.828-.07.937-.702.349-1.505.38-2.375.207z",
    fill: "#f19f50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.978 210.12c.422.008.577.169 1.176.136.478-.024 1.713-.549 1.907-.093.214.506.228.776.276 1.512.042.631-.085 1.516-.442 1.511-4.252-.071-4.297.604-6.164.289-.556-.092-1.224-.185-1.535-.849-.301-.645.692-.449 1.337-.7.972-.377 1.587-.67 2.25-1.109.728-.484.633-.708 1.195-.697z",
    fill: "#54384b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.81 213.618c.463-.377.164-1.127.143-1.177-.182-.456-.54-1.133-.656-1.64-.163-.71-.22-2.282-.153-2.979.281-2.945-2.674-1.969-2.742-.224-.051 1.282.506 1.847.992 2.991.199.47.496 1.345.583 1.854.153.884.014 1.08.427 1.494.12.121.488.135.65.053.203-.1.541-.195.756-.372z",
    fill: "#f19f50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.247 217.28c.35.187 1.727.262 2.257.262 1.496.006 1.398-.304 1.96-1.429.391-.78.553-1.718 1.602-2.028.945-.28.766-1.097.048-2.213-.354-.551-1.232-.282-1.673.059-.559.433-.657 1.127-1.161 1.866-.453.666-.76 1.169-1.396 1.958-.694.862-1.857.45-1.993.962-.11.414.249.504.356.563z",
    fill: "#54384b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.848 151.906c2.482 12.309 9.108 45.324 9.365 53.338.115 3.595.798 3.2 2.308 3.189 1.807-.014 1.958.865 2.546-3.981.752-6.201 2.067-10.865 1.555-17.858-.509-6.994-3.13-9.444-3.575-14.549-.445-5.106-.042-13.336 2.434-21.213 2.475-7.88-21.048-30.738-14.633 1.074z",
    fill: "url(#ap)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.275 142.82c-4.448 8.817-6.741 20.077-2.211 35.689 3.884 15.799 8.395 28.077 8.85 29.605.593 1.991.882 1.714 2.069 1.728 1.46.017 1.724.21 1.953-2.945.209-2.882 1.156-11.816.363-16.754-1.069-6.649-4.397-9.992-4.599-16.748-.206-6.859 1.329-9.687 4.853-17.59 9.754-21.87-4.042-27.325-11.278-12.985z",
    fill: "url(#aq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.4 121.089c.042-.005-.004-.084-.001-.126.008-.081.019-.162.028-.246.03-.249.079-.489.136-.735.186-.803.622-1.514.787-2.328.055-.268.147-.674.002-.931-.157-.28-.324-.146-.452.072-.186.319-.355.649-.529.977-.045.084-.155.425-.304.33-.233-.151-.375-.613-.466-.853-.263-.691-.481-1.41-.772-2.087-.165-.381-.484-.448-.763.002-.174.277-.479.582-.504 1.083-.039.691.056 1.027.274 1.634.311.861.624 1.757 1.136 2.526.061.092.123.187.187.277.203.288.932 1.264 1.188.495.029-.084.042-.174.052-.26",
    fill: "#f1d6bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.891 100.602c-2.734-1.5215-8.025-2.7691-9.899-2.8922-2.503-.165-5.526.1595-9.377 1.9498-6.104 2.8364-7.809 7.6534-9.319 13.8494-.56 2.297-1.308 8.071-4.028 8.751-1.89.475-3.589-.26-4.721-1.335-.845-.8-1.018-.629-1.585-.313-.667.372-.815.344-.674 1.491.113.915.283 2.011.415 2.54.719 2.876 3.399 4.951 6.864 5.298 3.686.37 7.295-1.37 9.391-4.131 3.487-4.596 4.064-4.191 3.434-.476-.388 2.286-.982 3.928-1.212 6.224-.557 5.567.053 14.063 2.911 18.961 1.474 2.526 5.772 4.274 8.567 5.351 2.227.856 8.232.834 10.568.979 7.365.462 8.649-1.801 15.989-.671 5.632.867 13.971 2.395 18.905-1.925 1.863-1.63 7.777-8.66 5.27-11.169-2.864-2.862-6.473.461-9.494-2.56-1.782-1.782-3.08-4.146-4.246-6.191-1.136-1.989-3.914-3.057-6.115-2.722-2.084.319-5.693 1.251-6.986-.914-2.872-4.812-2.089-11.948-3.396-17.182-1.488-5.95-6.14-10.068-11.262-12.913z",
    fill: "url(#ar)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.682 80.4185c-2.389.1762-3.623 1.2812-4.062 3.0659-.429 1.74.306 3.5219 1.836 4.087 3.108 1.1497 2.855-.5371 3.089 4.557.201 4.3723-2.739 6.9487-.355 11.1336 1.704 2.993 6.576 4.378 8.48 7.013 2.358 3.267.469 7.975 2.643 11.455 6.314 10.105 24.589 11.265 32.458 3.005 7.349-7.715 2.943-21.101-6.487-24.654-3.726-1.4067-8.42.507-11.315-.8053-3.228-1.4602-5.413-5.3682-8.398-7.3795-2.241-1.5106-4.515-1.1693-6.948-1.7037-7.67-1.6756-.619-10.5321-10.941-9.774z",
    fill: "url(#as)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step_1.845e2780b02266238d94929af5fc4384.svg";
export { ForwardRef as ReactComponent };